import { OnInit } from '@angular/core';
import { DetailService } from '../services/detail.service';
import { ToasterService, BodyOutputType } from 'angular2-toaster';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from '../services/confirmation.service';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { MessagePopupService } from '../services/message-popup.service';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
import { EnvService } from '../env.service';
import { TokenManager } from '../Globals';
import { HttpClient } from '@angular/common/http';
import { ResendVerificationComponent } from '../resend-verification/resend-verification.component';
import { BsModalService } from 'ngx-bootstrap/modal';
var SupplierRegistrationComponent = /** @class */ (function () {
    function SupplierRegistrationComponent(detailService, toasterService, router, modalService, confirmationService, toasterMessageService, messagePopupService, themeSettingService, globals, workspaceService, env, tokenManager, http) {
        this.detailService = detailService;
        this.router = router;
        this.modalService = modalService;
        this.confirmationService = confirmationService;
        this.toasterMessageService = toasterMessageService;
        this.messagePopupService = messagePopupService;
        this.themeSettingService = themeSettingService;
        this.globals = globals;
        this.workspaceService = workspaceService;
        this.env = env;
        this.tokenManager = tokenManager;
        this.http = http;
        this.isBusy = false;
        this.isSubmit = false;
        this.submitted = false;
        this.toasterService = toasterService;
        this.supplierHeaderText = this.env.supplierHeaderText;
        this.registerNote = this.env.registerNote;
        this.enableCaptcha = this.env.enableCaptcha;
        this.siteKey = this.env.captchaKey;
        this.supplierBackdrop = this.env.supplierBackdrop;
    }
    SupplierRegistrationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderConfig = this.themeSettingService.getTheme();
        document.querySelectorAll("body").item(0).style.position = "initial";
        this.requestSupplierRegistration();
        this.http.get("assets/external-html/supplier-registration.html", { responseType: "text" }).subscribe(function (result) {
            _this.supplierReg = result;
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
        });
    };
    SupplierRegistrationComponent.prototype.resolved = function (captchaResponse) {
        //console.log(`Resolved captcha with response: ${captchaResponse}`);
    };
    SupplierRegistrationComponent.prototype.requestSupplierRegistration = function () {
        var _this = this;
        this.isBusy = true;
        var actionKey = "";
        if (this.tokenManager.retrieve("BRNActionKey")) {
            actionKey = this.tokenManager.retrieve("BRNActionKey").replace(/["']/g, "");
        }
        this.detailService.requestSupplierRegistration(actionKey).subscribe(function (id) {
            if (id) {
                // this.tokenManager.delete("BRNActionKey");
                _this.componentId = id;
                _this.detailService.getAnonymousDetail(id).subscribe(function (cardResult) {
                    _this.detailObject = JSON.parse(cardResult);
                    _this.detailObject.Properties = _this.detailObject.Properties.filter(function (x) { return x.PropertyOrder != 0; }).filter(function (x) { return !x.PropertyIsHidden; });
                    _this.detailObject.Properties.forEach(function (property) {
                        if (property.ParentPropertyName) {
                            if (_this.detailObject.Properties.find(function (x) { return x.PropertyName == property.ParentPropertyName; })) {
                                _this.detailObject.Properties.find(function (x) { return x.PropertyName == property.ParentPropertyName; }).ChildPropertyName = property.PropertyName;
                            }
                        }
                    });
                    _this.detailObject.Captcha = "";
                    _this.isBusy = false;
                });
            }
        });
    };
    SupplierRegistrationComponent.prototype.submitForm = function (actionCommand, form) {
        if (form.valid) {
            this.detailAction(actionCommand);
        }
        else {
            this.submitted = true;
        }
    };
    SupplierRegistrationComponent.prototype.onValueChange = function (prop, value) {
        var _this = this;
        if (prop.ParentPropertyName) {
            if (this.supplierForm.control.get(prop.ParentPropertyName)) {
                if (value != this.supplierForm.control.get(prop.ParentPropertyName).value) {
                    setTimeout(function () {
                        _this.supplierForm.control.get(prop.PropertyName).setErrors({ noMatch: true });
                    });
                }
                else {
                    setTimeout(function () {
                        _this.supplierForm.control.get(prop.ParentPropertyName).setErrors(null);
                    });
                }
            }
        }
        else if (prop.ChildPropertyName) {
            if (this.supplierForm.control.get(prop.ChildPropertyName)) {
                if (value != this.supplierForm.control.get(prop.ChildPropertyName).value) {
                    setTimeout(function () {
                        _this.supplierForm.control.get(prop.PropertyName).setErrors({ noMatch: true });
                    });
                }
                else {
                    setTimeout(function () {
                        _this.supplierForm.control.get(prop.ChildPropertyName).setErrors(null);
                    });
                }
            }
        }
        if (value) {
            if (prop.PropertyDisplayFormat == 'UPPER') {
                value = value.toUpperCase();
            }
        }
        this.detailService.anonymousUpdateField(this.componentId, prop.PropertyName, value).subscribe(function (result) {
            // console.log(result);
        });
    };
    SupplierRegistrationComponent.prototype.detailAction = function (actionCommand) {
        var _this = this;
        this.isSubmit = true;
        this.detailService.anonymousDetailAction(this.componentId, actionCommand).subscribe(function (result) {
            _this.handleWorkflowReturn(result);
            _this.isSubmit = false;
        }, function (error) {
            _this.popToast('Error', 'Something unexpected happened', 'error');
            _this.isSubmit = false;
        });
    };
    SupplierRegistrationComponent.prototype.handleWorkflowReturn = function (result) {
        var _this = this;
        var command = JSON.parse(result);
        switch (command.ReturnType) {
            case 0:
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    this.router.navigate(path);
                }
                break;
            case 1:
                this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe(function (respond) {
                    if (respond.answer == "OK") {
                        if (command.SubType == "info") {
                            _this.router.navigate(["/"]);
                        }
                    }
                });
                break;
        }
        switch (command.RefreshType) {
            case "self":
                this.requestSupplierRegistration();
                break;
        }
    };
    SupplierRegistrationComponent.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.toasterMessageService.pushToaster(toaster);
            }
        };
        this.toasterService.pop(toast);
    };
    SupplierRegistrationComponent.prototype.resendVerificationEmail = function () {
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-resend-verification',
            focus: false
        };
        this.modalRef = this.modalService.show(ResendVerificationComponent, config);
        this.modalService.onHide.subscribe(function (reason) {
            if (document.querySelectorAll('.modal-backdrop').item(0)) {
                document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
            }
        });
        document.querySelectorAll('.modal-backdrop').item(0).classList.add('layer');
    };
    return SupplierRegistrationComponent;
}());
export { SupplierRegistrationComponent };
